// @flow

import React from 'react';
import { FormattedNumber } from 'react-intl';

export const formatCurrencyCell = (value: number | null | void) =>
  value == null ? (
    '—'
  ) : (
    <FormattedNumber
      value={value}
      style="currency"
      currency="USD"
      minimumFractionDigits={2}
    />
  );
